"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6813],{

/***/ 6813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ asg_team_list_AsgTeamList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/base/image/index.tsx + 1 modules
var base_image = __webpack_require__(5244);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 6 modules
var gridview = __webpack_require__(8117);
;// CONCATENATED MODULE: ./components/widgets/asg-team-list/AsgTeamList.tsx




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AsgTeamList = function(props) {
    var ref;
    var data = props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
        return _objectSpread({}, item, {
            isReverse: index % 2 !== 0
        });
    });
    var TextContent = function(itemData) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "text-wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "name-surname",
                    children: [
                        itemData.nameStatus,
                        " ",
                        itemData.name,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: itemData.surname
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "title",
                    children: itemData.title
                })
            ]
        }));
    };
    var ImageContent = function(itemData) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(base_image["default"], _objectSpread({
            alt: ""
        }, itemData.image, {
            style: {
                borderRadius: '30px'
            }
        })));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "team-list",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
            className: "team-item-wrapper",
            gutter: "md",
            justify: "center",
            align: "center",
            children: data === null || data === void 0 ? void 0 : data.map(function(item, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                    className: "column",
                    xs: {
                        size: 12
                    },
                    sm: {
                        size: 12
                    },
                    xl: {
                        size: 12
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContent, _objectSpread({}, item)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent, _objectSpread({}, item))
                        ]
                    })
                }, index);
            })
        })
    }));
};
/* harmony default export */ var asg_team_list_AsgTeamList = (AsgTeamList);

;// CONCATENATED MODULE: ./components/widgets/asg-team-list/index.tsx



/***/ })

}]);